import { Text } from '@react-pdf/renderer';
import { useLineItemPartId } from '@ui/hooks/useLineItemPartId';
import { QuoteFormLine } from '@ui/pages/QuoteBuilder/QuoteBuilder';
import { styles } from '@ui/pdfs/styles';

export function PartId({
  lineItem,
  siteCode,
}: {
  lineItem: QuoteFormLine;
  siteCode: string;
}) {
  const partId = useLineItemPartId(lineItem, siteCode);

  return partId ? (
    <Text style={[styles.bold, { paddingBottom: '4px' }]}>{partId}</Text>
  ) : null;
}
